var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2025 15.8334H18V17.5001H3V13.9642L11.25 5.71424L14.785 9.2509L8.20167 15.8334H8.2025ZM12.4275 4.53674L14.1958 2.7684C14.3521 2.61218 14.564 2.52441 14.785 2.52441C15.006 2.52441 15.2179 2.61218 15.3742 2.7684L17.7317 5.1259C17.8879 5.28218 17.9757 5.4941 17.9757 5.71507C17.9757 5.93604 17.8879 6.14796 17.7317 6.30424L15.9633 8.07174L12.4283 4.53674H12.4275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditWhite);
export default __webpack_public_path__ + "static/media/icon_edit_white.088c482b55dc0a3a368dc080cd7f1838.svg";
export { ForwardRef as ReactComponent };